import { useQuery } from "@/compat/reactQuery";
import userAccessPermissionService from "../../services/userAccessPermissionService";
import queryKeys from "../../constants/queryKeys";

const useUserAccessPermission = ({ userExternalId, hasSafetyNest }) =>
  useQuery(
    [queryKeys.userAccessPermission, userExternalId],
    () => userAccessPermissionService.getByUserExternalId(userExternalId),
    {
      enabled: !!userExternalId && hasSafetyNest,
    }
  );

export default useUserAccessPermission;
